<template>
  <div>
    <div class="text-h6 font-weight-bold mb-2">Account</div>

    <v-card rounded="xl" outlined>
      <v-card-text>
        Guest mode for now. Later we add login, order history, logout.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default { name: "RemoteStoreAccount" };
</script>